import { useLocation } from "react-router-dom";
import { Separator } from "./ui/separator";
import { SidebarTrigger } from "./ui/sidebar";
import { 
  Breadcrumb, 
  BreadcrumbItem, 
  BreadcrumbLink, 
  BreadcrumbList, 
  BreadcrumbPage, 
  BreadcrumbSeparator 
} from "./ui/breadcrumb";

export function SiteHeader() {
  const location = useLocation();
  
    // Generate breadcrumbs based on the current path
    const getBreadcrumbs = () => {
      const paths = location.pathname.split('/').filter(Boolean);
      
      // Default breadcrumbs for the root path
      if (paths.length === 0 || (paths.length === 1 && paths[0] === "workflows")) {
        return (
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Workflows</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        );
      }
      
      // Breadcrumbs for workflow pages
      if (paths[0] === "workflows") {
        // Determine the workflow type from the URL
        let workflowType = "Ontology Migration";
        if (paths.length > 1) {
          if (paths[1] === "process") {
            workflowType = "Process Migration";
          } else if (paths[1] === "ontology") {
            workflowType = "Ontology Migration";
          } else if (paths[1] === "linked-process") {
            workflowType = "Linked Process Migration";
          }
        }
        
        return (
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/workflows">Workflows</BreadcrumbLink>
              </BreadcrumbItem>
              {paths.length > 1 && (
                <>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{workflowType}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        );
      }
      
      // Breadcrumbs for logs page
      if (paths[0] === "logs") {
        return (
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Logs</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        );
      }
    
      // Breadcrumbs for session activity page
      if (paths[0] === "session-activity") {
        return (
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Session Activity</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        );
      }

    // Default fallback
    return (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/workflows">Workflows</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{paths[0]}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    );
  };

  // Get the title based on the current path
  const getTitle = () => {
    const paths = location.pathname.split('/').filter(Boolean);
    
    if (paths.length === 0 || (paths.length === 1 && paths[0] === "workflows")) {
      return "Workflows";
    }
    
    if (paths[0] === "workflow" || paths[0] === "workflows") {
      if (paths.length === 1) {
        return "Workflows";
      } else {
        // Determine the workflow type from the URL
        if (paths[1] === "process") {
          return "Process Migration";
        } else if (paths[1] === "ontology") {
          return "Ontology Migration";
        } else if (paths[1] === "linked-process") {
          return "Linked Process Migration";
        } else {
          return "Workflow Details";
        }
      }
    }
    
    if (paths[0] === "logs") {
      return "Logs";
    }

    if (paths[0] === "session-activity") {
      return "Session Activity";
    }

    return paths[0].charAt(0).toUpperCase() + paths[0].slice(1);
  };

  return (
    <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <div className="hidden md:block">
          {getBreadcrumbs()}
        </div>
        <h1 className="text-base font-medium md:hidden">{getTitle()}</h1>
      </div>
    </header>
  );
}
